import { render, staticRenderFns } from "./mySoft.vue?vue&type=template&id=4862f97d&scoped=true&"
import script from "./mySoft.vue?vue&type=script&lang=js&"
export * from "./mySoft.vue?vue&type=script&lang=js&"
import style0 from "./mySoft.vue?vue&type=style&index=0&id=4862f97d&prod&lang=less&"
import style1 from "./mySoft.vue?vue&type=style&index=1&id=4862f97d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4862f97d",
  null
  
)

export default component.exports